import styles from "./VisionAndMission.module.css";

export default function VisionAndMission() {
  return (
    <section className={styles.section}>
      <div className={styles.title}>Vision & Mission</div>
      <div className={styles.cardContainer}>
        <Card
          title="Vision"
          description="To be the most affordable, efficient, and user-friendly digital ease of business solution for micro and small entrepreneurs in India"
        />
        <Card
          title="Mission"
          description="Use StartAppify to create customized app-based solutions for specific business types, to start and run their early-stage businesses effectively, by unlocking the power of digital technology, thus becoming the most preferred growth partner for that segment. Our revenue will be a subscription model based on a fair-use framework. Being part of various startup ecosystems/platforms is an important part of our growth strategy."
        />
      </div>
    </section>
  );
}

function Card({ title, description }) {
  return (
    <div className={styles.card}>
      <div className={styles.title}>{title}</div>
      <div className={styles.desc}>{description}</div>
    </div>
  );
}
